// @flow
import type { IConstraintModel } from "../../types";

/**
 */
class PasswordMinSpecialCharactersConstraint implements IConstraintModel {
  _minSpecial: number;

  /**
   */
  constructor(minSpecial: number) {
    this._minSpecial = minSpecial;
  }

  /**
   */
  get id(): string {
    return "Constraint.Password.MinSpecialCharactersMandatory";
  }

  /**
   */
  get minSpecial(): number {
    return this._minSpecial;
  }

  /**
   */
  hasValidation(): boolean {
    return true;
  }

  /**
   */
  get defaultMessage(): string {
    return "Must contain ${min-special} or more special characters"; // NOSONAR
  }

  /**
   */
  get parameters(): { "min-special": number } {
    return {
      "min-special": this.minSpecial,
    };
  }

  /**
   */
  validate(value: string): boolean {
    return value.replace(/[\da-z]/giu, "").length >= this.minSpecial;
  }

  /**
   */
  get isMandatoryConstraint(): boolean {
    return false;
  }
}

export default PasswordMinSpecialCharactersConstraint;
